import { render, staticRenderFns } from "./FacetChipGroup.vue?vue&type=template&id=c9bd3318&scoped=true&"
import script from "./FacetChipGroup.vue?vue&type=script&lang=ts&"
export * from "./FacetChipGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FacetChipGroup.vue?vue&type=style&index=0&id=c9bd3318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bd3318",
  null
  
)

export default component.exports